// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2uFoq","right":"Footer_right__2H3S3","buttons":"Footer_buttons__2UMWf"};